import { useState, useEffect } from 'react';
import { useParams} from 'react-router-dom';
import axios from 'axios';
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./BusinessSlotReservation.css";



const IframeReservationForm = () => {
  const { businessId } = useParams();
  const [activeSlot, setActiveSlot] = useState([]);
  const [publicData, setPublicData] = useState(null);
  const [message, setMessage] = useState(null);
  const [waiting, setWaiting]= useState(false)
  const [reservationData, setReservationData] = useState({
    business: businessId,
    service: '',
    date: '',
    timeSlots: [],
    duration: 0,
  });
  const [quest, setQuest] = useState({
    name: "",
    phone: "",
    email: "",
  });
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [formatedSelectedDate, setFormatedSelectedDate] = useState(null);
  const [slots, setSlots] = useState([]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    setFormatedSelectedDate(formattedDate);
    setReservationData((prevData) => ({
      ...prevData,
      date: formattedDate,
    }));
  };

  useEffect(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    setFormatedSelectedDate(formattedDate);
    setReservationData((prevData) => ({
      ...prevData,
      date: formattedDate,
    }));
  }, []);

  useEffect(() => {
    if (quest) {
      setReservationData((prev) => ({ ...prev, quest }));
    }
  }, [quest]);

  useEffect(() => {
    const fetchPublicData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/business/public/${businessId}`);
        
        setPublicData(response.data);
      } catch (err) {
        setMessage(err.response?.data.message || err.message);
      }
    };
    fetchPublicData();
  }, [businessId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'service') {
      const selectedService = publicData.services.find(service => service._id === value);
      setReservationData((prevData) => ({
        ...prevData,
        [name]: value,
        duration: selectedService ? selectedService.duration : 0,
      }));
    } else {
      setReservationData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };
  const handleQuestChange = (e) => {
    const {name, value} = e.target

    setQuest((prev) => ({
        ...prev,
        [name]:value,
    }))
  }
 
  const addMinutesToTime = (time, minutes) => {
    if (!time || typeof time !== "string") {
      console.error("Invalid time format:", time);
      return "";
    }
    const [hours, minutesPart] = time.split(":").map(Number);
    const date = new Date(0, 0, 0, hours, minutesPart);
    date.setMinutes(date.getMinutes() + minutes);
    return `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
  };

  const selectedTimeSlots = (slot) => {
    const duration = reservationData.duration;
    const slotStartTime = slot.startTime;
    const selectedTimeSlots = [];
    let startTime = slotStartTime;
    let endTime = addMinutesToTime(startTime, 15);

    for (let i = 0; i < duration / 15; i++) {
      selectedTimeSlots.push(`${startTime} - ${endTime}`);
      startTime = endTime;
      endTime = addMinutesToTime(startTime, 15);
    }

    setReservationData((prevData) => ({
      ...prevData,
      timeSlots: selectedTimeSlots,
      available: false,
    }));

    setActiveSlot([slot]);
  };


  const reservationFormSubmit = async (e) => {
    e.preventDefault();
    console.log(reservationData)
    if (reservationData.quest) {
      if (reservationData.timeSlots.length === 0) {
        window.alert("Nezadali jste čas rezervace");
        return;
      }
      try {
        setWaiting(true)
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/reservation/quest-create`,
          reservationData
        );

        setMessage(response?.data?.message);

      } catch (err) {
        setMessage(err.response?.data?.message || err.message);
      } finally {
        setWaiting(false)
        setTimeout(() => {
            setMessage(null)
          }, 1000);
      }
    }
  };

  useEffect(() => {
    const fetchAvailableSlots = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/reservation/availableslots`, {
          params: { businessId, date: formatedSelectedDate },
        });
        setSlots(response.data.availableDates);
      } catch (error) {
        setMessage(error.data?.message || "Slot je obsazený");
      }
    };

    if (formatedSelectedDate) {
      fetchAvailableSlots();
    }
  }, [formatedSelectedDate, businessId]);

  return (
    <div className='business-container'>
      <form onSubmit={reservationFormSubmit}>
    <div className='quest-input-container'>
         <input 
                type='text'
                value={quest.name}
                name='name'
                placeholder='Jméno a přijmení'
                onChange={handleQuestChange}
                className="login-input"
                required
            />
      <input 
                type='tel'
                value={quest.phone}
                name='phone'
                placeholder='Telefon'
                onChange={handleQuestChange}
                className="login-input"
                required
            />
      <input 
                type='email'
                value={quest.email}
                name='email'
                placeholder='Email'
                onChange={handleQuestChange}
                className="login-input"
                required
            />
      </div> 
            
        <div className='basic-container'>
          <h2 className='check-title'>Vyberte službu: </h2>
          <select
            name="service"
            value={reservationData.service}
            onChange={handleInputChange}
            className="reservation-select basic-input"
          >
            <option value="" disabled>Možnosti</option>
            {publicData?.services?.map((service) => (
              <option key={service._id} value={service._id}>
                {service.name}
              </option>
            ))}
          </select>
        </div>

        <Calendar onChange={handleDateChange} />

        {reservationData.service ? (
          <div>
            {slots
              .filter((day) => day.date === formatedSelectedDate)
              .map((slot, index) => (
                <div key={index} className="time-slot-container">
                  {slot.workHours.map((timeSlot, timeIndex) => (
                    <div
                      key={timeIndex}
                      className={`time-slot ${timeSlot.available ? "available" : "notAvailable"} 
                        ${activeSlot.some(active => active.startTime === timeSlot.startTime) ? "active" : ""}`}
                      onClick={timeSlot.available ? () => selectedTimeSlots(timeSlot) : () => alert("Slot je obsazený")}
                    >
                      <span>{timeSlot.startTime}</span>
                    </div>
                  ))}
                </div>
              ))}
          </div>
        ) : (
          <p className='slot-warning'>Pro zobrazení volných termínů vyberte službu</p>
        )}

        <div className='slot-conteiner iframe'>
          {selectedDate && (
            <div className="slot-price-iframe">
              <h2 className="check-title">Vybraný datum: </h2>
              <p>{selectedDate.toLocaleDateString()}</p>
            </div>
          )}

          {reservationData.service && (
            <div className="slot-price-iframe">
              <h2 className="check-title">Trvání služby: </h2>
              <p>{reservationData.duration} minut</p>
            </div>
          )}

          {activeSlot.length > 0 && (
            <div>
              {activeSlot.map((item, index) => (
                <div className="slot-price-iframe" key={index}>
                  <h2 className='check-title'>Kdy: </h2>
                  <p>{item.startTime}</p>
                </div>
              ))}
            </div>
          )}
        </div>

        <button type="submit" className="hotel-submit-button">{waiting ? "Vytvářím..." : "Potvrdit"}</button>
      </form>

      {message && <p className='message'>{message}</p>}
      <div className='powered'><p>powered by </p><a href="https://resanio.com" target="_blank" rel="noopener noreferrer">
  RESANIO.com
</a></div>
    </div>
  );
};

export default IframeReservationForm;